import { useState } from 'preact/hooks';

interface Props {
    open: boolean;
    title?: string;
    message: string;
    onConfirm: () => void | Promise<void>;
    onCancel: () => void;
}

export default function ConfirmModal({ open, title, message, onConfirm, onCancel }: Props) {
    const [loading, setLoading] = useState(false);

    if (!open) return null;

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm();
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center" onClick={!loading ? onCancel : undefined}>
            <div className="bg-base-100 rounded-lg shadow-xl max-w-sm w-full mx-4" onClick={e => e.stopPropagation()}>
                {title && <div className="px-5 pt-5 text-base font-semibold">{title}</div>}
                <div className="px-5 py-4 text-sm text-base-content/80">{message}</div>
                <div className="px-5 pb-4 flex justify-end gap-2">
                    <button className="btn btn-sm btn-ghost" onClick={onCancel} disabled={loading}>Отмена</button>
                    <button className="btn btn-sm btn-accent" onClick={handleConfirm} disabled={loading}>
                        {loading ? <span className="loading loading-spinner loading-xs" /> : 'Подтвердить'}
                    </button>
                </div>
            </div>
        </div>
    );
}
